import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import emailjs from '@emailjs/browser';
// ─── EmailJS Configuration ────────────────────────────────────────────────────
const SERVICE_ID = 'service_doctorecommerce';
const TEMPLATE_ID = 'template_realestate';
const PUBLIC_KEY = 'YOUR_PUBLIC_KEY';
export function ContactForm() {
  const formRef = useRef<HTMLFormElement>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState('');
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!formRef.current) return;
    setIsSubmitting(true);
    setError('');
    try {
      await emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, formRef.current, PUBLIC_KEY);
      setIsSuccess(true);
    } catch (err) {
      setError('Hubo un error al enviar. Por favor intenta de nuevo o contáctanos directamente.');
    } finally {
      setIsSubmitting(false);
    }
  };
  const inputClass = 'w-full bg-dark-300/80 border border-dark-100/50 rounded-lg px-5 py-4 text-white placeholder-gray-600 focus:border-gold/40 focus:ring-1 focus:ring-gold/20 outline-none transition-all text-base';
  const labelClass = 'text-gray-500 text-xs font-bold uppercase tracking-widest mb-2 block';
  const selectClass = `${inputClass} appearance-none cursor-pointer`;
  return <section id="contacto" className="py-24 md:py-32 px-5 md:px-8 bg-gradient-to-b from-dark-300 to-carbon relative" data-id="element-1">
      <div className="max-w-4xl mx-auto" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-3">
          <h2 className="text-3xl md:text-5xl font-black text-white tracking-tight mb-6 uppercase" data-id="element-4">
            Aplica Ahora —{' '}
            <span className="text-gold" data-id="element-5">Cupos Limitados por Zona</span>
          </h2>
          <p className="text-gray-400 text-lg md:text-xl max-w-2xl mx-auto" data-id="element-6">
            Completa el formulario y un especialista te contactará en menos de
            24 horas.
          </p>
        </motion.div>

        {isSuccess ? <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} className="bg-emerald/10 border border-emerald/30 p-12 rounded-2xl text-center shadow-2xl" data-id="element-7">
            <div className="text-6xl mb-6" data-id="element-8">✅</div>
            <h3 className="text-3xl font-black text-emerald mb-4 uppercase" data-id="element-9">
              ¡Aplicación Recibida!
            </h3>
            <p className="text-gray-300 text-lg mb-10 max-w-md mx-auto" data-id="element-10">
              Nuestro equipo revisará tu información y se pondrá en contacto
              contigo en menos de 24 horas.
            </p>
            <a href="https://calendar.app.google/PYPdcRoYne7QrNJA7" target="_blank" rel="noopener noreferrer" className="inline-block bg-gold text-carbon font-black py-5 px-10 rounded-md hover:shadow-[0_0_30px_rgba(242,183,5,0.4)] transition-all uppercase tracking-widest text-sm md:text-base" data-id="element-11">
              ACELERA EL PROCESO: AGENDA TU LLAMADA AHORA
            </a>
          </motion.div> : <motion.form ref={formRef} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} onSubmit={handleSubmit} className="relative bg-dark-200/80 backdrop-blur-xl border border-gold/10 p-8 md:p-12 rounded-2xl shadow-2xl overflow-hidden" data-id="element-12">
            <div className="absolute top-0 left-0 w-full h-[2px] bg-gold" data-id="element-13" />

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-14">
              <div data-id="element-15">
                <label className={labelClass} data-id="element-16">Nombre Completo *</label>
                <input required type="text" name="user_name" className={inputClass} placeholder="Ej. Juan Pérez" data-id="element-17" />
              </div>
              <div data-id="element-18">
                <label className={labelClass} data-id="element-19">Email *</label>
                <input required type="email" name="user_email" className={inputClass} placeholder="juan@ejemplo.com" data-id="element-20" />
              </div>
              <div data-id="element-21">
                <label className={labelClass} data-id="element-22">Teléfono / WhatsApp *</label>
                <input required type="tel" name="user_phone" className={inputClass} placeholder="+1 (555) 000-0000" data-id="element-23" />
              </div>
              <div data-id="element-24">
                <label className={labelClass} data-id="element-25">Compañía / Brokerage *</label>
                <input required type="text" name="company_name" className={inputClass} placeholder="Ej. Keller Williams" data-id="element-26" />
              </div>
              <div data-id="element-27">
                <label className={labelClass} data-id="element-28">Instagram</label>
                <input type="text" name="instagram" className={inputClass} placeholder="@tuusuario" data-id="element-29" />
              </div>
              <div data-id="element-30">
                <label className={labelClass} data-id="element-31">Website (si tienes)</label>
                <input type="url" name="website" className={inputClass} placeholder="https://tuweb.com" data-id="element-32" />
              </div>
              <div className="md:col-span-2" data-id="element-33">
                <label className={labelClass} data-id="element-34">
                  Zona de Servicio Principal *
                </label>
                <input required type="text" name="zona" className={inputClass} placeholder="Ciudad, Estado" data-id="element-35" />
              </div>
              <div data-id="element-36">
                <label className={labelClass} data-id="element-37">
                  Transacciones actuales por mes *
                </label>
                <select required name="current_clients" className={selectClass} data-id="element-38">
                  <option value="" data-id="element-39">Selecciona una opción</option>
                  <option value="0-1" data-id="element-40">0 a 1 transacción</option>
                  <option value="2-4" data-id="element-41">2 a 4 transacciones</option>
                  <option value="5-10" data-id="element-42">5 a 10 transacciones</option>
                  <option value="10+" data-id="element-43">Más de 10 transacciones</option>
                </select>
              </div>
              <div data-id="element-44">
                <label className={labelClass} data-id="element-45">
                  Meta mensual de transacciones *
                </label>
                <select required name="goal_clients" className={selectClass} data-id="element-46">
                  <option value="" data-id="element-47">Selecciona una opción</option>
                  <option value="3-5" data-id="element-48">3 a 5 transacciones</option>
                  <option value="6-10" data-id="element-49">6 a 10 transacciones</option>
                  <option value="11-20" data-id="element-50">11 a 20 transacciones</option>
                  <option value="20+" data-id="element-51">Más de 20 transacciones</option>
                </select>
              </div>
              <div data-id="element-52">
                <label className={labelClass} data-id="element-53">
                  ¿Has hecho publicidad digital antes? *
                </label>
                <select required name="has_done_ads" className={selectClass} data-id="element-54">
                  <option value="" data-id="element-55">Selecciona una opción</option>
                  <option value="no" data-id="element-56">No, nunca</option>
                  <option value="si_malos" data-id="element-57">Sí, con malos resultados</option>
                  <option value="si_buenos" data-id="element-58">Sí, con buenos resultados</option>
                </select>
              </div>
              <div data-id="element-59">
                <label className={labelClass} data-id="element-60">Gasto aproximado en ads</label>
                <select name="ad_spend" className={selectClass} data-id="element-61">
                  <option value="" data-id="element-62">Selecciona una opción</option>
                  <option value="0" data-id="element-63">$0 — Nunca he invertido</option>
                  <option value="500-2000" data-id="element-64">$500 – $2,000</option>
                  <option value="2000-10000" data-id="element-65">$2,000 – $10,000</option>
                  <option value="10000+" data-id="element-66">Más de $10,000</option>
                </select>
              </div>
            </div>

            {error && <p className="mt-8 text-red-400 text-sm text-center bg-red-500/10 border border-red-500/20 rounded-lg p-4 font-medium" data-id="element-67">
                {error}
              </p>}

            <div className="pt-10 mt-10 border-t border-dark-100 flex flex-col items-center gap-5" data-id="element-68">
              <button type="submit" disabled={isSubmitting} className="w-full relative overflow-hidden group inline-flex items-center justify-center px-8 py-5 font-black text-carbon bg-gold rounded-md hover:shadow-[0_0_30px_rgba(242,183,5,0.4)] transition-all duration-300 disabled:opacity-60 disabled:cursor-not-allowed tracking-widest uppercase text-sm md:text-base" data-id="element-69">
                <span className="relative z-10" data-id="element-70">
                  {isSubmitting ? 'ENVIANDO...' : 'QUIERO MI DIAGNÓSTICO GRATUITO'}
                </span>
                <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-71" />
              </button>
              <a href="https://calendar.app.google/PYPdcRoYne7QrNJA7" target="_blank" rel="noopener noreferrer" className="text-gold/70 text-sm md:text-base underline hover:text-gold transition-colors font-medium tracking-wide" data-id="element-72">
                O agenda directamente →
              </a>
            </div>
          </motion.form>}
      </div>
    </section>;
}